import { render, staticRenderFns } from "./AppGeneral.vue?vue&type=template&id=7ba57d18&"
import script from "./AppGeneral.vue?vue&type=script&lang=js&"
export * from "./AppGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\wamp\\www\\themes-coder\\rawal\\rawal-laravel11\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ba57d18')) {
      api.createRecord('7ba57d18', component.options)
    } else {
      api.reload('7ba57d18', component.options)
    }
    module.hot.accept("./AppGeneral.vue?vue&type=template&id=7ba57d18&", function () {
      api.rerender('7ba57d18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/settings/AppGeneral.vue"
export default component.exports